import { ChevronDown } from 'lucide-react';

/** A bare string is used as both value and label. */
type NativeSelectOption = string | { value: string; label: string };

export function NativeSelect({
  value,
  onChange,
  options,
  placeholder,
  variant = 'default',
}: {
  value: string;
  onChange: (v: string) => void;
  options: NativeSelectOption[];
  placeholder?: string;
  variant?: 'default' | 'pill';
}) {
  const isPill = variant === 'pill';
  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={
          isPill
            ? 'border-smoke bg-neutral-white h-8 appearance-none rounded-full border pl-3 pr-7 text-sm text-black focus:outline-none'
            : 'border-smoke bg-neutral-white focus:ring-primary-s500 h-11 w-full appearance-none rounded-lg border px-3 pr-9 text-base text-black focus:ring-2 focus:outline-none'
        }
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => (
          typeof o === 'string' ? (
            <option key={o} value={o}>{o}</option>
          ) : (
            <option key={o.value} value={o.value}>{o.label}</option>
          )
        ))}
      </select>
      <ChevronDown
        size={isPill ? 12 : 14}
        className={`text-silver pointer-events-none absolute top-1/2 -translate-y-1/2 ${isPill ? 'right-2' : 'right-3'}`}
      />
    </div>
  );
}
